import React from 'react';
import dynamic from 'next/dynamic';

import { NextImage } from 'common/components';
import { useTheme } from '@zydalabs/storefront-components';
import { useResponsive } from 'common/hooks';

const SFCarouselComponent = dynamic(() => import('common/components/SFCarousel'));

type MenuItemImagesType = {
  itemImage: string;
  variantImages: Array<{ photoUrl: string }>;
};

const MenuItemImages: React.FC<MenuItemImagesType> = ({ itemImage, variantImages }) => {
  const theme = useTheme();
  const imageUrl = variantImages?.[0]?.photoUrl;
  const isMobile = useResponsive(`max-width: ${theme.screenBreakpoints.small}`);
  const isDesktop = useResponsive(`min-width: ${theme.screenBreakpoints.large}`);
  const isTablet = isMobile || isDesktop;

  if (variantImages?.length > 1) {
    return (
      <SFCarouselComponent dynamicHeight={false}>
        {variantImages.map((variantImage, index) => (
          <NextImage
            key={variantImage.photoUrl}
            src={variantImage.photoUrl}
            alt="product"
            data-testid="variant-image"
            layout={isTablet ? 'responsive' : 'fill'}
            width={isTablet ? 500 : undefined}
            height={isTablet ? 500 : undefined}
            objectFit="cover"
            type="product"
            sizes={`(min-width: ${theme.screenBreakpoints.large}) 30vw, 100vw`}
            priority={!index}
          />
        ))}
      </SFCarouselComponent>
    );
  }

  return (
    <NextImage
      src={imageUrl}
      alt="product"
      data-testid="variant-image"
      layout={isTablet ? 'responsive' : 'fill'}
      width={isTablet ? 500 : undefined}
      height={isTablet ? 500 : undefined}
      objectFit="cover"
      type="product"
      fallBackImageUrl={itemImage}
      sizes={`(min-width: ${theme.screenBreakpoints.large}) 30vw, 100vw`}
      priority
    />
  );
};

export default MenuItemImages;
